import { Moment } from "moment";
import { StringHelper } from "../../../../../../helper";
import { AFLType } from "../../models";
import { DateFormat } from "../../../../../../constants";

export const form11 = (record: any) => {
  return {
    departmentCode: "2",
    aflType: AFLType.AccidentNotification,
    layout: [
      {
        type: "header",
        value: {
          form: 2,
          department: StringHelper.verticalBarSplit(record?.eDepartment)[1],
        },
      },
      {
        type: "title",
        value: { sub: [] },
      },
      {
        type: "salutation",
        value: [
          "- Trưởng phòng/trung tâm",
          "- Trưởng phòng Tổ chức hành chính.",
        ],
      },
      {
        type: "content",
        value: [
          { type: "eRequestName", value: record?.eRequestName },
          { type: "eEmployeeId", value: record?.eEmployeeId },
          {
            type: "ePosition",
            value: StringHelper.verticalBarSplit<string[]>(record?.eTeam)[1],
          },
          {
            type: "eWorkPlace",
            value: StringHelper.verticalBarSplit<string[]>(
              record?.eDepartment
            )[1],
          },
          {
            type: "",
            value:
              "Nay tôi kính thông báo đến Trưởng phòng/trung tâm về việc tai nạn rủi ro/tai nạn giao thông với nội dung như sau:",
          },

          {
            type: "eAccidentTime2",
            value: (record?.eAccidentTime as Moment).format(
              DateFormat.DD_MM_YYYY
            ),
          },
          { type: "eAccidentLocation", value: record?.eAccidentLocation },
          { type: "eAccidentReason", value: record?.eReason || "" },
          { type: "eStatus", value: record?.eStatus },
          {
            type: "",
            value:
              "Rất mong Trưởng phòng/trung tâm tạo điều kiện giúp đỡ trong thời gian tôi chữa trị.",
          },
          { type: "", value: "Xin trân trọng cảm ơn." },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "recipients",
            value: [
              "- Như trên;",
              "- TCHC (để biết);",
              "- Lưu: phòng/trung tâm. ",
            ],
          },
          {
            type: "signature1",
            value: ["NGƯỜI LÀM ĐƠN", record?.eRequestName],
          },
        ],
      },
      {
        type: "footer",
        value: [
          {
            type: "signature1",
            value: [
              "PHÊ DUYỆT CỦA TRƯỞNG PHÒNG/TRUNG TÂM",
              record?.eApprovalProcess[1][0].name,
            ],
          },
        ],
        textBreak: 1,
      },
    ],
  };
};
